<template>
  <div class="booking-list">
    <div class="booking-division" />

    <div class="booking-header-search">
      <form action="/">
        <van-search
          v-model="searchForm.value"
          placeholder="请输入搜索关键词"
          @search="onSearch"
          show-action
        >
          <template #action>
            <div @click="onSearch(searchForm.value)">搜索</div>
          </template>
        </van-search>
      </form>
    </div>
    <div class="booking-division" />
    <div class="booking-list-main">
      <div
        class="booking-list-item"
        v-for="item in orderList"
        :key="item.id"
      >
        <div class="booking-list-item-option">
          <div>
            {{ item.product_name }}
          </div>
          <div>
            {{ allEnum.OrderPayStatus && allEnum.OrderPayStatus[item.pay_status] }}
          </div>
        </div>
        <div class="booking-list-item-option">
          <div>
            分享人：{{ item.create_user_name }}
          </div>
          <div>
            {{ moment(item.create_time).format('YYYY-MM-DD HH:mm') }}
          </div>
        </div>
        <div class="booking-list-item-option">
          <div>
            客户信息：{{ item.customer_name }}
          </div>
          <div>
            {{ item.customer_mobile2 }}
          </div>
        </div>
        <div class="booking-list-item-option">
          <div>

          </div>
          <div class="booking-list-item-action">
            <span
              class="booking-label"
              @click="goQrCode(item)"
            >
              生成二维码
            </span>
            <span
              class="booking-label"
              @click="copy(item.pay_url)"
            >
              复制链接
            </span>
          </div>
        </div>
        <div class="booking-division" />

      </div>
    </div>
  </div>
</template>

<script>
import bookingService from "@/apis/booking";
import getUserInfo from "@/models/userInfo";
import moment from "moment";
import { Toast } from "vant";
import enums from "@/views/booking/mixins/enums";

export default {
  data() {
    return {
      orderList: [],
      searchForm: {},
      currentUserInfo: {},
    };
  },
  mixins: [enums],

  async created() {
    const userInfo = await getUserInfo();
    this.currentUserInfo = userInfo;
    this.getOrderList();
  },
  methods: {
    moment,
    copy(content) {
      // navigator.clipboard.writeText(content);
      if (navigator.clipboard && window.isSecureContext) {
        // navigator clipboard 向剪贴板写文本
        Toast("复制成功");
        return navigator.clipboard.writeText(content);
      } else {
        // 创建text area
        const textArea = document.createElement("textarea");
        textArea.value = content;
        // 使text area不在viewport，同时设置不可见
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        Toast("复制成功");
        return new Promise((res, rej) => {
          // 执行复制命令并移除文本框
          document.execCommand("copy") ? res() : rej();
          textArea.remove();
        });
      }
    },
    onSearch(query) {
      this.getOrderList(query);
    },
    getOrderList(query = "") {
      const { currentUserInfo } = this;
      const params = {
        create_user_id: currentUserInfo.user_id,
        keyword: query,
      };
      bookingService.orderList(params).then((res) => {
        this.orderList = res;
      });
    },
    goQrCode(item) {
      this.$router.push({
        name: "BookingQrCode",
        query: {
          type: "order",
          id: item.id,
          userId: this.currentUserInfo.user_id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.booking-list-item {
  .booking-list-item-option {
    display: flex;
    justify-content: space-between;
    padding: 15px 20px;
    border-bottom: 1px solid rgba(0, 48, 87, 0.1);
    & > div:nth-child(2) {
      // flex-shrink: 0;
    }
  }
  .booking-list-item-action {
    display: flex;
    span {
      margin-left: 15px;
    }
  }
}
.booking-label {
  cursor: pointer;
}
</style>